export default __webpack_public_path__ + "static/media/Purified Sweetpressed Haste.b4e835e8.jpg";